<template>
	<el-dialog title="培训报名名单" :visible.sync="showActivityVisible" width="576px" center append-to-body :close-on-click-modal="false">
		<Table
			:loading="loading"
			:table-data="tableData"
			:total="total"
			:table-head="tableHead"
			:current-page.sync="queryData.current"
			:page-size.sync="queryData.size"
			@change-page="getShowList"
			:tableHeight="tableHeight"
			:showOperation="false"
		>
		</Table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="showActivityVisible = false">关 闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	components: {
		Table: () => import('@/components/Table/table'),
	},
	data() {
		return {
			showActivityVisible: false,
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			tableHead: [
				{
					label: '报名人',
					prop: 'placer',
					formatter: function (row) {
						return row.placer?.title || '-';
					},
				},
				{
					label: '联系方式',
					prop: 'placer',
					formatter: function (row) {
						return row.placer?.description || '-';
					},
				},
				{
					label: '报名时间',
					prop: 'createTime',
					width: 160,
					formatter: function (row) {
						return row.createTime || '-';
					},
				},
				// {
				// 	label: '支付方式',
				// 	prop: 'entranceTicket',
				// 	width: 120,
				// 	formatter: function (row) {
				// 		return row.entranceTicket || '0';
				// 	},
				// 	default: 0,
				// },
				// {
				// 	label: '支付金额',
				// 	prop: 'priceCny',
				// 	width: 100,
				// 	formatter: (row) => {
				// 		return row.priceCny ? row.priceCny / 100 + '元' : '-';
				// 	},
				// },
			],
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 410;
		},
	},
	mounted() {},
	methods: {
		//获取列表
		getShowList(params) {
			this.loading = true;
			let data = {
				...this.queryData,
				trainingId: params.id,
			};
			this.$http
				.get(this.api['TrainingApplications#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						this.tableData = res.data.collection || [];
						this.total = res.data.pagination.totalItems || 0;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .page-box {
	height: 50px;
	margin-top: 10px;
}
</style>